import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { HedefLogo } from '../components/HedefLogo'
import type { MaintenanceInfo } from '../lib/maintenance'
import './maintenance.css'

/**
 * Planli bakim ekrani.
 *
 * ## Neden tam ekran
 *
 * Bakim sirasinda uygulamanin GERI KALANI calismiyor: modeller bellekten
 * bosaltiliyor, yeni uretim kabul edilmiyor. Kenarda bir uyari seridi
 * gostermek kullaniciyi calismayan dugmelere tiklamaya davet ederdi.
 *
 * ## Ne soyluyor
 *
 * Uc soru yanitlaniyor, cunku bakim ekranlarinin ise yaramama sebebi
 * genellikle bunlardan birini atlamalari: NE oluyor, NE ZAMAN bitecek,
 * benim isime NE oldu. Sonuncusu icin acik bir cumle var - konusmalar
 * kayitli, yarim kalan yanit kaybolmuyor.
 */
export function MaintenanceScreen({ info, preview }: { info: MaintenanceInfo; preview?: boolean }) {
  const { t, i18n } = useTranslation()
  const [now, setNow] = useState(() => Date.now())

  // Saniye saniye DEGIL dakikada bir: geri sayim saniyeyle akarsa kullanici
  // ekrana bakip bekliyor. Dakika, "simdi ne yapayim" karari icin yeterli.
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 30_000)
    return () => window.clearInterval(timer)
  }, [])

  const end = info.expected_end_at ? Date.parse(info.expected_end_at) : null
  const remaining = end !== null ? Math.max(0, Math.round((end - now) / 60000)) : null
  const endLabel =
    end !== null
      ? new Date(end).toLocaleTimeString(i18n.language, { hour: '2-digit', minute: '2-digit' })
      : null

  return (
    <main className="mnt" role="status" aria-live="polite">
      {preview && <p className="mnt-preview">{t('maintenance.previewNote')}</p>}

      <div className="mnt-card">
        <span className="mnt-logo">
          <HedefLogo height={26} />
        </span>

        {/* Dis halka doner, ic nokta sabit: "calisiyor" sinyali, ama
            ilerleme CUBUGU degil - yuzde bilmiyoruz, uydurmak yanlis olur. */}
        <span className="mnt-spinner" aria-hidden="true">
          <span className="mnt-spinner-dot" />
        </span>

        <h1>{t('maintenance.title')}</h1>
        <p className="mnt-lead">{info.message || t('maintenance.lead')}</p>

        <dl className="mnt-facts">
          {endLabel && (
            <div>
              <dt>{t('maintenance.expectedEnd')}</dt>
              <dd>{endLabel}</dd>
            </div>
          )}
          {remaining !== null && (
            <div>
              <dt>{t('maintenance.remaining')}</dt>
              <dd>
                {remaining > 0
                  ? t('maintenance.remainingValue', { count: remaining })
                  : t('maintenance.remainingSoon')}
              </dd>
            </div>
          )}
        </dl>

        <p className="mnt-safe">{t('maintenance.dataSafe')}</p>

        <button type="button" className="btn-primary mnt-retry" onClick={() => location.reload()}>
          {t('maintenance.retry')}
        </button>
        <p className="mnt-auto">{t('maintenance.autoNote')}</p>
      </div>
    </main>
  )
}
